import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    blogList: () => {
        return HTTP.get('/article/list', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    changeStatusBlog: (id) => {
        return HTTP.post(`/article/on_off/${id}`,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addBlog: (data) => {
        return HTTP.post('/article/create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editBlog: (id,data) => {
        return HTTP.post(`/article/update/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    blogDetail: (id) => {
        return HTTP.get(`/article/edit/${id}`, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deleteBlog: (id) => {
        return HTTP.post(`/article/destroy/${id}`,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}